export default function assetUrl(url) {
  if (!url) return url;
  if (typeof url !== "string") return url;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;

  const base = import.meta.env.BASE_URL || "/";
  const normalizedBase = base.endsWith("/") ? base : `${base}/`;
  return url.startsWith("/") ? `${normalizedBase}${url.slice(1)}` : `${normalizedBase}${url}`;
}
